import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Locale } from "../../common/constants";
import { setStorageItem } from "../../common/StorageItem";
import "../main.css";

class LocalesMenu extends React.Component<WithTranslation> {
  constructor(props: WithTranslation) {
    super(props);

    this.handleLangChange = this.handleLangChange.bind(this);
  }

  handleLangChange(e: React.ChangeEvent<HTMLSelectElement>) {
    this.props.i18n.changeLanguage(e.target.value);
    setStorageItem({ language: e.target.value });
  }

  render() {
    const { i18n } = this.props;
    const locales = Locale.LOCALES.map((locale, i) => {
      return (
        <option value={locale.lang} key={i}>
          {locale.label}
        </option>
      );
    });
    const locale = Locale.LOCALES.find((locale) => {
      return locale.lang === i18n.language;
    });
    const value = locale ? locale.lang : Locale.NOTEXIST;
    return (
      <select className="locale" value={value} onChange={this.handleLangChange}>
        {locales}
      </select>
    );
  }
}

export default withTranslation()(LocalesMenu);
